import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb } from 'react-bootstrap';
import { Field } from 'redux-form';
import { withRouter } from 'react-router';
import { I18n, Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import _, { isInteger } from 'lodash';
import axios from 'axios';
import moment from 'moment';

import { DatePicker } from '../Common/datePicker';
import { DEFAULT_ERROR, UI_HEIGHT } from '../Common/constants';
import { InputField, DisabledInputField } from '../Common/inputField';
import { Selection, DisabledSelection, SelectionWithProps } from '../Common/selection'
import BoldDecimalTextFormatter from '../Common/boldDecimalTextFormatter';
import Bold5DecimalTextFormatter from '../Common/bold5DecimalTextFormatter';
import PurchaseOrderAutoSuggest from '../Common/PurchaseOrderAutoSuggest';
import { convertLocalDate, timeTOYmdOrMdy } from '../Common/cleanDates';
import { numberWithCommas } from '../Common/numberWithCommas';
import { DateFormatter } from '../Common/dateFormat';
import checkPermission from '../Common/permissions';
import SetReceiveWeightModal from '../../containers/Inventories/setReceiveWeightModal';
import WarehouseDropdown from './warehouseDropdown';
import Spinner from '../../components/Widgets/spinner';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import SetWeightModal from '../../containers/Dispatch/setWeightModal';
import warehouseManagementModal from '../Common/modals/warehouseManagement';
import {
  ROOT_URL, ROOT_API_URL, isSH, isAP, isOCM, isGGI, isLAP, isUSPrideMulti, isAPD,
  isOLG, isVAK, isSV, isHO, isJRC, isGFD, isCCW, isTU, isSW
} from '../../actions/root_url';
import SetQualityControlModal from './setQualityControlModal';
import SetDispatchLocationModal from './setDispatchLocationModal';
import { fetchLogicalLocation } from '../../actions/receive_actions';
import ConfirmActionModal from '../Common/confirmActionModal';
import ProductColorsModal from '../Common/modals/product/ProductColorsModal';
import ProductEditColorsModal from '../Common/modals/product/ProductEditColorsModal'

const {
  LocationSelectModal,
  AutoCodesModal,
} = warehouseManagementModal;

const isAFGRelated =  (ROOT_URL === "https://afg-scm.truckxi.com/api/" || ROOT_URL === "https://afgstage-scm.truckxi.com/api/" || ROOT_URL === "https://mmdavis-scm.truckxi.com/api/");
const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afgstage-scm.truckxi.com/api/';
const isMMD = ROOT_API_URL === 'https://mmdavis-scm.truckxi.com/api/' || ROOT_URL === 'https://mmdavis-scm.truckxi.com/api/';
const isTN = ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || ROOT_URL === "https://tn-scm.truckxi.com/api/";
const isUSPride = ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || ROOT_URL === 'https://uspride-scm.truckxi.com/api/';

const isNumeric = function (n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

class DateEditor extends React.Component {
  constructor(props) {
    super(props);
    this.dateInputRef = null;
    this.state = {
      dropUp: false,
    }
  }

  componentDidMount() {
    let rect = this.getInputNode().getBoundingClientRect();
    let tableElement = document.getElementById('ReceiveHistoryDetail-dataGrid1');
    let tableToBottom = tableElement.getBoundingClientRect().bottom;
    let distanceToBottom = tableToBottom - rect.bottom;
    if(distanceToBottom < 260) {
      this.setState({
        dropUp: true,
      })
    }
  }

  componentWillUnmount() {
    let cells = document.querySelectorAll('.react-grid-Cell').forEach(cell => {
      cell.style.zIndex = "unset";
    });
  }
  
  getStyle() {
    return {
      width: '100%'
    };
  }

  getValue() {
    let updated = {};
    let packageDate;
    if(this.getInputNode().querySelector('input').value) {
      packageDate = moment(this.getInputNode().querySelector('input').value).format('MM-DD-YYYY');
    } else {
      packageDate = moment().format('MM-DD-YYYY');
    }
    updated[this.props.column.key] = packageDate;
    return updated;
  }

  getInputNode() {
    return ReactDOM.findDOMNode(this.dateInputRef);
  }

  inheritContainerStyles() {
    return true;
  }

  render() {
    const {rowData} = this.props;
    return <DateTimePicker
    ref={ref => this.dateInputRef = ref}
    placeholder={'MM-DD-YYYY'}
    format="MM-DD-YYYY"
    className={'test-rw-input'}
    time={false}
    date={true}
    dropUp={this.state.dropUp}
    onChange={(date) => {
      this.getInputNode().querySelector('input').value = moment(date).format('MM-DD-YYYY');
      this.props.onCommit();
    }}
    onToggle={(e)=>{
      if(e == 'calendar') {
        let cell = document.querySelector('.react-grid-Cell.editing');
        cell.style.zIndex = 100;
      } else {
        let cell = document.querySelector('.react-grid-Cell.editing');
        cell.style.zIndex = 'unset';
      }
    }}
    onBlur={()=>{
     let cells = document.querySelectorAll('.react-grid-Cell').forEach(cell => {
        cell.style.zIndex = "unset";
      });
    }}
    value={rowData[this.props.column.key] ? new Date(rowData[this.props.column.key]): undefined}
    defaultValue={undefined}
    />
  }
}


class ReceiveHistoryDetail extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,

      setWeightOpen: false,
      totalLoaded: null,
      rowChosen: -1,

      productNum: null,
      instock: null,
      purchased: null,
      sold: null,
      totalPrice: null,

      rows: [],
      originRows: [],
      selectedInventoryRow: {},
      editedRows: [],
      selectedRows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,
      MiscCost: 0,
      HandlingCost: 0,
      ShippingCost: 0,
      priceAdjustment: 0,
      InvoiceFinalPrice: 0,
      currentWeights: null,
      suggestValue: '',
      isSaving: false,
      PdfFrameLoaded: true,
      TaxRate: 0,
      TotalCRV: 0,
      confirmOpen: false,
      status: '',
      case: '',
      vendorOptions1: [],
      vendorOptions2: [],
      isLocationSelectModalVisible: false,
      qualityControlModalVisibility: false,
      dispatchLocationModalVisibility: false,
      isFinalizeConfirmationModalVisible: false,
      isAutoCodesModalVisible: false,
      qualifiedLocationOptions: [],
      unqualifiedLocationOptions: [],
      isSpare: false,
    };

    this.handleResize = this.handleResize.bind(this);
    this.openSetWeight = this.openSetWeight.bind(this);
    this.closeSetWeight = this.closeSetWeight.bind(this);
    this.setRows = this.setRows.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.fetchDetail();
    let {vendorOptions1, vendorOptions2} = this.state;
    axios.get(
      `${ROOT_URL}v2/general/vendor?depth=1&fields=id,name,vendor_num,payment_term&is_active=true&order=name`,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      if (response && response.data && response.data.vendors) {
        response.data.vendors.map(r => {
          vendorOptions1.push({label: r.name, value: r.id});
          vendorOptions2.push({label: r.vendor_num, value: r.id});
        });
      }
      this.setState({vendorOptions1, vendorOptions2});
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      alert(err.data);
    });  //?
  }

  fetchDetail = () => {
    const { currentReceiveHistory } = this.props;
    if (currentReceiveHistory) {
      this.setState({
        status: currentReceiveHistory.ArrivalStatus
      })
      this.props.fetchReceiveHistoryDetailRecord(currentReceiveHistory.WarehouseReceive_id, currentReceiveHistory.Warehouse_ReceiveCompleted_id).then(() => {
        this.props.setDefaultSearchType('RefNum', 'receiveHistoryDetail');
      });
    } else {
      this.props.setDefaultSearchType('RefNum', 'receiveHistoryDetail');
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    // this.props.resetEditReceiveHistory();
  }

  componentWillReceiveProps(nextProps) {
    if(parseFloat(nextProps.MiscCost) !== this.state.MiscCost)
      this.setState({MiscCost: parseFloat(nextProps.MiscCost)});
    if(parseFloat(nextProps.HandlingCost) !== this.state.HandlingCost)
      this.setState({HandlingCost: parseFloat(nextProps.HandlingCost)});
    if(parseFloat(nextProps.ShippingCost) !== this.state.ShippingCost)
      this.setState({ShippingCost: parseFloat(nextProps.ShippingCost)});
    if (parseFloat(nextProps.priceAdjustment) !== this.state.priceAdjustment) {
      this.setState({ priceAdjustment: parseFloat(nextProps.priceAdjustment) });
    }
    if(parseFloat(nextProps.InvoiceFinalPrice) !== this.state.InvoiceFinalPrice)
      this.setState({InvoiceFinalPrice: parseFloat(nextProps.InvoiceFinalPrice)});
    if(parseFloat(nextProps.TaxRate) !== this.state.TaxRate)
      this.setState({TaxRate: parseFloat(nextProps.TaxRate)});
    if(parseFloat(nextProps.TotalCRV) !== this.state.TotalCRV)
      this.setState({TotalCRV: parseFloat(nextProps.TotalCRV)});
    if(nextProps.currentReceiveHistoryDetail != null && nextProps.currentReceiveHistoryDetail != this.props.currentReceiveHistoryDetail){
      if(nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line_Completed){
        var newRows = [...nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line_Completed];
        newRows.map((newRow, index) => {
          newRow["RcvUnitPrice"] = newRow["RcvUnitPrice"] ? newRow["RcvUnitPrice"] : newRow["FOBUnitPrice"];
          newRow["subWeights"] = [];
          if (!isVAK) {
            if(newRow.Weights){
              newRow.Weights.map(w => {
                newRow["subWeights"].push({'Weight': w})
              })
            }
          }
          if(isCCW || isAP) {
            newRow['index'] = index;
          }
        })
        this.setState({ rows: newRows, });
      } else {
        let newRows = nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line;
        newRows.map((newRow, index) => {
          newRow["subWeights"] = [];
          if (!isVAK) {
            if(newRow.Weights){
              newRow.Weights.map(w => {
                newRow["subWeights"].push({'Weight': w})
              })
            }
          }
          if(isCCW || isAP) {
            newRow['index'] = index;
          }
        })
        this.setState({ rows: this.setDataIndex(newRows), originRows: newRows });
      }
      if (isVAK) {
        this.fetchLogicalLocations(this.props.selectedCompany, {value: nextProps.currentReceiveHistoryDetail.Warehouse_id});
      }
    }
    if (nextProps.purchaseOrderProduct && nextProps.purchaseOrderProduct !== this.props.purchaseOrderProduct) {
      this.selectInventoryInfo(nextProps.purchaseOrderProduct);
      if(!(isVAK || isAP)) {
        this.props.fetchProductInfo(nextProps.purchaseOrderProduct.Product_id);
      }
      this.props.setDefaultOfForm('Weight', nextProps.purchaseOrderProduct.NetWeight, 'receiveHistoryDetail');
      if(!(isGGI || isGFD)) {
        this.props.setDefaultOfForm('unitPrice', nextProps.purchaseOrderProduct.ProductCost, 'receiveHistoryDetail');
      }
      this.props.setDefaultOfForm('itemNotation', '', 'receiveHistoryDetail');
    }

    if (nextProps.warehouseReceivePdf && nextProps.warehouseReceivePdf !== this.props.warehouseReceivePdf) {
      this.setState({ PdfFrameLoaded: false });
    }

    if (nextProps.editedReceiveHistory && nextProps.editedReceiveHistory !== this.props.editedReceiveHistory) {
      if(isOLG || isHO || isJRC || isCCW) {
        this.setState({
          rows: this.setDataIndex(nextProps.editedReceiveHistory.Warehouse_Receive_Line),
          originRows: this.setDataIndex(nextProps.editedReceiveHistory.Warehouse_Receive_Line),
        })
      }
      this.openConfirm();
    }
    if (nextProps.warehouse && nextProps.warehouse !== this.props.warehouse) {
      if (isVAK) {
        this.fetchLogicalLocations(this.props.selectedCompany, nextProps.warehouse);
      }
    }
  }

  setDataIndex(lines) {
    if(isCCW || isGGI) {
      return lines.map((line, index)=> {
        return {...line, index};
      })
    } else {
      return lines;
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded == false) {
      return false;
    }
    return true;
  }

  fetchLogicalLocations = (company, warehouse) => {
    fetchLogicalLocation(company.value, warehouse.value).then(response => {
      this.setState({
        qualifiedLocationOptions: response.excellent_location.map((location, index) => ({id: index, value: location.zone_num, text: location.description})),
        unqualifiedLocationOptions: response.defective_location.map((location, index) => ({id: index, value: location.zone_num, text: location.description})),
      })
    })
  }
  handleResize(e) {
    this.setState({tableHeight: window.innerHeight-UI_HEIGHT.twoLineButton});
  }

  closeSetWeight() {
    this.setState({setWeightOpen: false});
  }

  openSetWeight() {
    this.setState({setWeightOpen: true});
  }

  openConfirm = () => {
    this.setState({ confirmOpen: true });
  }

  closeConfirm = () => {
    this.setState({ confirmOpen: false });
  }

  handleKeyPress = (value, event) => {
    if (event.charCode === 13) {
      event.preventDefault();
      if (value === 'unitPrice' || value === 'itemNotation') {
        if ((!isNumeric(this.props.quantityValue) ||  this.props.quantityValue < 0) && value !== 'quantity') {
          return;
        }
      }
      // if (value === 'quantity' && this.state.selectedInventoryRow.InStock == null) {
      //   return;
      // }
      ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
    }
  }

  handleSetSelect = (row) => {
    if(isGGI) {
      this.props.setDefaultOfForm('ConvertNum', row.ConvertNum, 'receiveHistoryDetail');
      this.props.setDefaultOfForm('unitPrice', row.ProductCost, 'receiveHistoryDetail');
    }
    if (isGFD) {
      this.props.setDefaultOfForm('ConvertNum', row.ConvertNum, 'receiveHistoryDetail');
      this.props.setDefaultOfForm('unitPrice', row.CaseCost, 'receiveHistoryDetail');
    }
  }

  renderAutoSuggest() {
    const { currentReceiveHistoryDetail } = this.props;
    const Warehouse_id = currentReceiveHistoryDetail && currentReceiveHistoryDetail.Warehouse_id
    return (
      <PurchaseOrderAutoSuggest
        value={this.state.suggestValue}
        onChange={(e, { newValue }) => {this.setState({ suggestValue: newValue }); }}
        handleKeyPress={this.handleKeyPress}
        handleFocusQty={this.handleFocusQty}
        setAllProductQuantity={this.setAllProductQuantity}
        SearchType={this.props.searchType}
        warehouse={this.props.warehouse || Warehouse_id}
        handleSetSlect = {this.handleSetSelect}
        isFLTPO={isGGI}
      />
    );
  }

  returnTotalWeight(totalWeight, loadedWeights) {
    let rows = [...this.state.rows];
    const {
      RcvQuantity,
      RcvUnitPrice,
      RcvSmallUnitPrice,
      ConvertNum,
    } = rows[this.state.currentRow];

    rows[this.state.currentRow].RcvTotalWeight = roundTo(totalWeight, 4).toFixed(2);
    if (rows[this.state.currentRow].ProductType === 'Fixed'){
      if(isGGI) {
        rows[this.state.currentRow].RcvTotalPrice = roundTo(parseFloat(RcvQuantity) * RcvSmallUnitPrice * ConvertNum, 2).toFixed(2);
      } else {
        rows[this.state.currentRow].RcvTotalPrice = roundTo(parseFloat(RcvQuantity) * RcvUnitPrice, 2).toFixed(2);
      }
    } else {
      if(isGGI) {
        rows[this.state.currentRow].RcvTotalPrice = roundTo(totalWeight * RcvSmallUnitPrice, 2).toFixed(2);
        rows[this.state.currentRow].RcvUnitPrice = roundTo((totalWeight/RcvQuantity) * RcvSmallUnitPrice, 2).toFixed(2);
      } else {
        rows[this.state.currentRow].RcvTotalPrice = roundTo(totalWeight * RcvUnitPrice, 2).toFixed(2);
        // if (isCCW) {
        rows[this.state.currentRow].RcvQuantity = loadedWeights.length;
        // }
      }
    }
    this.setState({ rows });
  }

  setWeights = (currentRow, currentWeights, editedRow) => {
    let index = 0;
    let Weights = [];
    let subWeights = [];
    currentWeights.map(row => {
      Weights.push(+roundTo(parseFloat(row.Weight), 2).toFixed(2));
      subWeights.push({ Weight: +roundTo(parseFloat(row.Weight), 2).toFixed(2) });
    });
    const rows = [...this.state.rows];
    rows[currentRow].Weights = Weights;
    rows[currentRow].subWeights = subWeights;
    this.setState({ rows });
  }

  keepLoaded = (oldLoaded) => {
    let rows = [...this.state.rows];
    rows[this.state.currentRow].RcvQuantity = oldLoaded;
    this.setState({ rows });
  }

  handleColorsVisible = () => {
    this.setState({
      productColorsVisible: true,
    })
  }
  handleCloseColorsVisible = () => {
    this.setState({
      productColorsVisible: false,
      currentProductId: '',
      currentProductIndex: -1,
    })
  }
  handleEditColorsVisible = () => {
    this.setState({
      productEditColorsVisible: true,
    })
  }
  handleCloseEditColorsVisible = () => {
    this.setState({
      productEditColorsVisible: false,
      currentProductId: '',
      currentProductIndex: -1,
    })
  }

  handleClearColorByProductId = () => {
    let rows = this.state.rows.map((row, index) => {
      if(index == this.state.currentProductIndex) {
        return {...row, color: ''};
      }
      return {...row};
    });
    this.setState({rows, productColorsVisible: false, currentProductId: '', currentProductIndex: -1})
  }
  handleUpdateColorByProductId = (color) => {
    let rows = this.state.rows.map((row, index) => {
      if(index == this.state.currentProductIndex) {
        return {...row, color};
      }
      return {...row};
    });
    this.setState({rows, productColorsVisible: false, currentProductId: '',  currentProductIndex: -1})
  }

  renderTotalWeight = () => {
    if (isCCW) {
      let qty = 0;
      let totalWT = 0;
      const rows = Data.Selectors.getRows(this.state);
      rows.forEach(row => {
        qty += parseInt(row.RcvQuantity);
        totalWT += row.RcvTotalWeight * 100;
      })
      return <div style={{ width: '250px', fontSize: '16px', fontWeight: 'bold' }}>Total Qty: {qty}  Total WT: {(totalWT/100).toFixed(2)}</div>
    }
  }

  renderTable() {
    const that = this;
    if (this.props.detailIsLoading && !this.props.error) return <Spinner/>
    else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{this.props.error}</div></ContentWrapper>
    else {
      
      const { currentReceiveHistoryDetail } = this.props;
      let isAPDTransfer = false;
      if (isAPD && currentReceiveHistoryDetail && currentReceiveHistoryDetail.IsTransfer) {
        isAPDTransfer = true;
      }
      // Parameters of the react-data-grid
      const getRows = () => {
        return Data.Selectors.getRows(this.state);
      }

      const getSize = () => {
        return getRows().length;
      }

      const rowGetter = rowIdx => {
        var rows = getRows();
        return Object.assign({}, rows[rowIdx]);
      }

      const onRowSelect = rows => {
        this.setState(...this.state, { selectedRows: rows });
      }

      const onRowsSelected = (rows) => {
        let newRows = this.state.rows;
        rows.map (r => {
          newRows[r.rowIdx].isSelected = true;
        });
        this.setState({rows: newRows});
      }

      const onRowsDeselected = (rows) => {
        let newRows = this.state.rows;
        rows.map (r => {
          newRows[r.rowIdx].isSelected = false;
        });
        this.setState({rows: newRows});
      }

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
        if (sortColumn === 'expire_datetime' && isGGI) {
          let rows = [...this.state.rows];
          rows.sort((a, b) => {
            const dateA = moment(a.expire_datetime);
            const dateB = moment(b.expire_datetime);
            // const A = a.expire_datetime.split('-');
            // const B = b.expire_datetime.split('-');
            // const dateA = A[2]+A[0]+A[1];
            // const dateB = B[2]+B[0]+B[1];
            if (sortDirection === "ASC") {
              return dateB - dateA
            } else if (sortDirection === "DESC"){
              return dateA - dateB
            } else {
              return a.index - b.index
            }
          });
          this.setState({
            rows,
            sortColumn: null,
            sortDirection: "NONE"
          })
          return;
        }
        this.setState(state);
      }

      const handleFilterChange = filter => {
        let newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
        } else {
            delete newFilters[filter.column.key];
        }
        this.setState({ filters: newFilters });
      }

      const onRowClick = (rowIdx, row) => {
        this.props.fetchSalesOrders();
      }

      // Handle the editable function
      const handleRowUpdated = e => {
        var rows = getRows();
        // let totalPrice = this.state.totalPrice;
        // totalPrice = totalPrice ? totalPrice:0;
        // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
        if(e.updated.RcvQuantity != null){
          if(rows[e.rowIdx].ProductType == "Non-Fixed") {
            let updated = {...e.updated};
            let oldQty = rows[e.rowIdx].RcvQuantity || 0;
            if (parseFloat(updated.RcvQuantity) < 0)
              updated.RcvQuantity = 0;
            Object.assign(rows[e.rowIdx], updated);
            this.setState({currentRow: e.rowIdx, totalLoaded: parseFloat(rows[e.rowIdx].RcvQuantity), rowChosen: e.rowIdx, currentWeights: rows[e.rowIdx].Weights, editedRow: rows[e.rowIdx], oldQty});
            if (isVAK) {
              Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].NetWeight) || 0) * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0), 2).toFixed(2) });
              Object.assign(rows[e.rowIdx], { RcvTotalWeight: +roundTo((parseFloat(e.updated.RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].NetWeight) || 0), 2).toFixed(2) });
              Object.assign(rows[e.rowIdx], e.updated);
            } else {
              this.openSetWeight();
            }
          }
          else {
            // totalPrice = (parseFloat(totalPrice) || 0) + ((parseFloat(e.updated.RcvQuantity) || 0) - (parseFloat(rows[e.rowIdx].RcvQuantity) || 0))*(parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0);
            let newWeight = (parseFloat(rows[e.rowIdx].RcvQuantity)) ? (rows[e.rowIdx].RcvTotalWeight/rows[e.rowIdx].RcvQuantity) * (parseFloat(e.updated.RcvQuantity)) : 0;
            newWeight = parseFloat(parseFloat(newWeight).toFixed(2));
            Object.assign(rows[e.rowIdx], {RcvTotalWeight: newWeight});
            if(isGGI) {
              Object.assign(rows[e.rowIdx], {RcvTotalPrice: (roundTo(parseFloat(e.updated.RcvQuantity)*rows[e.rowIdx].RcvSmallUnitPrice * rows[e.rowIdx].ConvertNum, 2).toFixed(2))});
            } else {
              Object.assign(rows[e.rowIdx], {RcvTotalPrice: (roundTo(parseFloat(e.updated.RcvQuantity)*rows[e.rowIdx].RcvUnitPrice, 2).toFixed(2))});
            }
            Object.assign(rows[e.rowIdx], e.updated);
          }
          if (isGFD) {
            Object.assign(rows[e.rowIdx], {RcvUnitQuantity: e.updated.RcvQuantity * rows[e.rowIdx].purchase_convert_unit });
          }
        }
        else if(e.updated.RcvUnitPrice != null){
          if(rows[e.rowIdx].ProductType == "Non-Fixed" || rows[e.rowIdx].ProductType == "Per-Pound") {
            // totalPrice = parseFloat(totalPrice) + (e.updated.RcvUnitPrice - rows[e.rowIdx].RcvUnitPrice)*rows[e.rowIdx].RcvTotalWeight;
            Object.assign(rows[e.rowIdx], {RcvTotalPrice: roundTo(parseFloat(e.updated.RcvUnitPrice)*rows[e.rowIdx].RcvTotalWeight, 2).toFixed(2)});
          }
          else {
            // totalPrice = parseFloat(totalPrice) + (e.updated.RcvUnitPrice - rows[e.rowIdx].RcvUnitPrice)*rows[e.rowIdx].RcvQuantity;
            Object.assign(rows[e.rowIdx], {RcvTotalPrice: roundTo(parseFloat(e.updated.RcvUnitPrice)*rows[e.rowIdx].RcvQuantity, 2).toFixed(2)});
          }
          Object.assign(rows[e.rowIdx], e.updated);
          this.setState({ currentWeights: rows[e.rowIdx].Weights });
        }
        else if(e.updated.RcvTotalWeight != null) {
          if(rows[e.rowIdx].ProductType == "Non-Fixed" || rows[e.rowIdx].ProductType == "Per-Pound") {
            // totalPrice = parseFloat(totalPrice) + (parseFloat(e.updated.RcvTotalWeight) - (parseFloat(rows[e.rowIdx].RcvTotalWeight) || 0))*rows[e.rowIdx].RcvUnitPrice;
            if(isGGI) {
              Object.assign(rows[e.rowIdx], {RcvTotalPrice: roundTo(parseFloat(e.updated.RcvTotalWeight)*parseFloat(rows[e.rowIdx].RcvSmallUnitPrice), 2).toFixed(2)});
            } else {
              Object.assign(rows[e.rowIdx], {RcvTotalPrice: roundTo(parseFloat(e.updated.RcvTotalWeight)*parseFloat(rows[e.rowIdx].RcvUnitPrice), 2).toFixed(2)});
            }
            Object.assign(rows[e.rowIdx], e.updated);
          }
        }
        else if (e.updated.RcvTotalPrice != null) {
          if(rows[e.rowIdx].ProductType == "Non-Fixed" || rows[e.rowIdx].ProductType == "Per-Pound") {
            if(isGGI) {
              Object.assign(rows[e.rowIdx], {
                RcvSmallUnitPrice: (parseFloat(e.updated.RcvTotalPrice) / parseFloat(rows[e.rowIdx].RcvTotalWeight)).toFixed(4)
              });
            } else {
              Object.assign(rows[e.rowIdx], {
                RcvUnitPrice: (parseFloat(e.updated.RcvTotalPrice) / parseFloat(rows[e.rowIdx].RcvTotalWeight)).toFixed(4)
              });
            }
          } else {
            Object.assign(rows[e.rowIdx], {
              RcvUnitPrice: (parseFloat(e.updated.RcvTotalPrice) / parseFloat(rows[e.rowIdx].RcvQuantity)).toFixed(4)
            });
          }
          Object.assign(rows[e.rowIdx], e.updated);
        } else if(isGGI && e.updated.RcvSmallUnitPrice != null) {
          Object.assign(rows[e.rowIdx], {
            RcvSmallUnitPrice:parseFloat(e.updated.RcvSmallUnitPrice).toFixed(2),
            RcvUnitPrice: (parseFloat(e.updated.RcvSmallUnitPrice) * parseFloat(rows[e.rowIdx].ConvertNum)).toFixed(4),
            RcvTotalPrice: (parseFloat(e.updated.RcvSmallUnitPrice) * parseFloat(rows[e.rowIdx].ConvertNum) * parseFloat(rows[e.rowIdx].RcvQuantity)).toFixed(4)
          });
        } else if(isCCW && e.updated.package_date != null) {
          let shiftLife = rows[e.rowIdx].ProductShiftLife || 0;
          let expTm = moment(e.updated.package_date).add(shiftLife, 'days').format('MM-DD-YYYY');
          Object.assign(rows[e.rowIdx], { package_date: e.updated.package_date, expire_datetime:expTm});
        } else {
          Object.assign(rows[e.rowIdx], e.updated);
        }
        // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
        let totalPrice = 0;
        rows.map(r => {
          totalPrice += parseFloat(r.RcvTotalPrice)
        })
        this.setState({rows:rows, totalPrice: totalPrice});
      }

      // Column difinition
      const IsFixedFormatter = React.createClass({
        render() {
          if (this.props.dependentValues.ProductType === "Non-Fixed") {
            return <span style={{ 'font-weight': 'bold' }}>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
          } else {
            return <span style={{ 'font-weight': 'bold' }}>{this.props.value}</span>;
          }
        }
      });

      const IsVariableFormatter = React.createClass({
        render() {
          return <span>
            <Button
              bsStyle="danger"
              className="textAlignStyle"
              style={{ height: '23px', width: '39px', padding: '0px' }}
              disable={isAPDTransfer}
              onClick={ () => {
                that.moveOffFromProductsList(this.props.dependentValues.WarehouseReceiveLine_id, (this.props.dependentValues.index || 0)) } }
            >
                <Translate value="X" />
            </Button>
          </span>;
        }
      });

      const renderRCVTW = () => {
        if (isSH || isAP) return <Translate value="rcv_pcs" />
        return <Translate value="rcv_tw" />
      }
      const showReceivePrice = !checkPermission('no_show_product_cost');
      const expireParams = (isCCW || isGFD) ? {
        editor: DateEditor,
      } : {};
      const columns = [
        {
          key: 'Delete',
          name: <Translate value="del" />,
          formatter: IsVariableFormatter,
          width: 50,
          getRowMetaData: (row) => row
        },
        ...isOLG ? [] : [{
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true
        }],
        {
          key: 'ProductRefNum',
          name: <Translate value={isOLG ? "item_no" : isVAK ? "sku" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'ProductName',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 160,
          filterable: true
        },
        {
          key: 'ProductDescription',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 85,
          filterable: true
        },
        ...isAP ? [
          {
            key: 'pkg_quantity',
            name: <Translate value="box" />,
            resizable: true,
            sortable: true,
            width: 85,
          },
          {
            key: 'pkgsize1',
            name: <Translate value="package_size" />,
            resizable: true,
            sortable: true,
            width: 85,
            getRowMetaData: row => row,
            formatter: ({dependentValues}) => {
              let pkgsize = `${dependentValues.pkgsize1}${dependentValues.pkgunit1}*${dependentValues.pkgsize2}${dependentValues.pkgunit2}`
              return <div>
                {pkgsize}
              </div>
            }
          }
        ] : [{
          key: 'PackageSize_1',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 85,
          filterable: true
        }],
        ...(isGFD) ? [{
          key: 'purchase_convert_unit',
          name: <Translate value="convert_num" />,
          resizable: true,
          sortable: true,
          width: 85,
          filterable: true
        },] : [],
        {
          key: 'OrderQuantity',
          name: <Translate value={(isSH || isAP) ? "shipped_qty" : isGFD ? "order_case_qty" : "order_qty"} />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true
        },
        {
          key: 'RcvQuantity',
          name: <Translate value={isGFD ? "rcv_case_qty" : "rcv_qty"} />,
          resizable: true,
          editable: isAPDTransfer ? false : true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: IsFixedFormatter,
          getRowMetaData: (row) => row,
        },
        ...(isGFD) ? [{
          key: 'RcvUnitQuantity',
          name: <Translate value="rcv_unit_qty" />,
          resizable: true,
          sortable: true,
          width: 85,
          filterable: true
        },] : [],
        ...((!isVAK && !isSW) || (isVAK && showReceivePrice) || (isSW && showReceivePrice)) && [{
          key: 'RcvUnitPrice',
          name: isGFD ? <Translate value="receive_$" /> : <Translate value="receive_unit_dollarsign" />,
          resizable: true,
          editable: !isGGI,
          // editable: (isAFGRelated ? (checkPermission('change_receiving_history_quantity_price') && this.state.status !== 'Received') : (checkPermission('change_receiving_history_quantity_price'))) ,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: BoldDecimalTextFormatter,
        }, {
          key: 'RcvTotalPrice',
          name: <Translate value="receive_total_dollarsign" />,
          resizable: true,
          editable: isOCM,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: BoldDecimalTextFormatter,
        }],
        {
          key: 'RcvTotalWeight',
          name: renderRCVTW(),
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true
        },
        ...isVAK ? [] : [{
          key: 'Batch_PONum',
          name: <Translate value="batch_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true
        }],
        ...isVAK ? [{
          name: <Translate value="qc_status"/>,
          resizable: true,
          width: 150,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => {
            if (dependentValues.DefectiveQuantity !== null && dependentValues.DefectiveQuantity !== undefined && dependentValues.DefectiveQuantity !== '') {
              return <div>{dependentValues.ExcellentQuantity + ' / ' + dependentValues.ConcessionQuantity + ' / ' + dependentValues.DefectiveQuantity}</div>
            }
            return <div />
          }
        }] : [{
          key: 'location',
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          width: 130,
          filterable: true,
          getRowMetaData: row => row,
          formatter: (props, index) => {
            const {
              dependentValues,
            } = props;
            return <div style={{ width: '100%', height: '20px', }} onDoubleClick={(e) => {
              e.preventDefault();
              this.setState({
                editingLine: dependentValues,
              });
              this.setLocationSelectModalVisibility(true);
            }}>{dependentValues.location}</div>
          }
        }],
        ...isGGI && [{
          key: 'ggi_batch',
          name: <Translate value="ggi_batch" />,
          resizable: true,
          editable: true,
          sortable: true,
          width: 60,
          filterable: true,
        }],
        ...(isAPD || isGGI) && [{
          key: 'lot_num',
          name: <Translate value="lot_no" />,
          resizable: true,
          sortable: true,
          editable: (isAPD && !isAPDTransfer) ? true : false,
          width: 60,
          filterable: true,
        }],
        ...isVAK ? [] : [{
          key: 'expire_datetime',
          name: <Translate value="exp_date" />,
          resizable: true,
          sortable: true,
          editable: isAPDTransfer ? false : true,
          width: 120,
          filterable: true,
          getRowMetaData: row => row,
          ...expireParams,
        }],
        {
          key: 'Remark',
          name: <Translate value="remark" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true
        },
        {
          key: 'StorageRate',
          name: <Translate value="storage_rate" />,
          resizable: true,
          editable: isAPDTransfer ? false : true,
          sortable: true,
          width: 80,
          filterable: true
        },
        {
          key: 'Pallet',
          name: <Translate value="pallet" />,
          resizable: true,
          editable: isAPDTransfer ? false : true,
          sortable: true,
          width: 80,
          filterable: true
        },
        ...isVAK && [{
          key: 'Is_Spare',
          name: <Translate value="is_spare" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: ({value}) => {
            return <span>{value == true ? 'yes' : 'no'}</span>
          }
        },
        {
          key: 'Note',
          name: <Translate value="note" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true
        }],
      ];

      if (isGGI) {
        const unitIdx = _.findIndex(columns, { key: "RcvUnitPrice" });
        const small_price = {
          key: "RcvSmallUnitPrice",
          name: <Translate value="small_pr" />,
          resizable: true,
          width: 80,
          sortable: true,
          editable: true,
        };
        columns.splice(unitIdx, 0, small_price);
        const expIdx = _.findIndex(columns, { key: "expire_datetime" });
        const case_per_layer = {
          key: "case_per_layer",
          name: <Translate value="case_per_layer" />,
          resizable: true,
          width: 120,
          sortable: true,
          editable: true,
        };
        const layer_per_pallet = {
          key: "layer_per_pallet",
          name: <Translate value="layer_per_pallet" />,
          resizable: true,
          width: 120,
          sortable: true,
          editable: true,
        }
        columns.splice(expIdx, 0, case_per_layer, layer_per_pallet);
      }

      if (isUSPrideMulti) {
        const index1 = _.findIndex(columns, { key: "RcvTotalWeight" });
        columns.splice(index1, 1);
        const index2 = _.findIndex(columns, { key: "expire_datetime" });
        const temp1 = {
          key: "PackageSize_1",
          name: <Translate value="volume_cft" />,
          resizable: true,
          width: 80,
          sortable: true,
        };
        columns.splice(index2, 1, temp1);
      }

      if ((isLAP || isUSPrideMulti || isAPD) || isCCW) {
          const expIdx = _.findIndex(columns, { key: "expire_datetime" });
          if (expIdx !== -1) {
            let packDateParams = isCCW ? {
              getRowMetaData: row => row,
              editor: DateEditor,
            } : {}
            columns.splice(expIdx, isCCW ? 0 : 1, {
              key: 'package_date',
              name: <Translate value="package_date" />,
              resizable: true,
              sortable: true,
              editable: true,
              width: 140,
              filterable: true,
              ...packDateParams,
            });
          }
        }
        
      return (
        <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="ReceiveHistoryDetail-dataGrid1">
          <ReactDataGrid
            rowKey='BatchNum'
            enableCellSelect={true}
            onGridSort={handleGridSort}
            onAddFilter={handleFilterChange}
            columns={columns}
            rowGetter={rowGetter}
            headerRowHeight={45}
            rowHeight={25}
            rowsCount={getSize()}
            // enableRowSelect='single'
            onRowUpdated={handleRowUpdated}
            //   rowSelection={{
            //     showCheckbox: true,
            //     enableShiftSelect: true,
            //     onRowsSelected: onRowsSelected,
            //     onRowsDeselected: onRowsDeselected,
            //     selectBy: {
            //      isSelectedKey: 'isSelected'
            //     }
            //  }}
            minHeight={isCCW ? 576 : 485} />
        </div></Col></Row>
      )
    }
  }

  dateStringFormat(date) {
    var month = date.getMonth() + 1;
    if (month < 10)
      month = "0" + month;
    var day = date.getDate();
    if (day < 10)
      day = "0" + day;
    var year = date.getFullYear();
    return month + '/' + day + '/' + year;
  }

  renderPOInformation() {
    let PONum = null;
    let POTotal = null;
    let POFinal = null;
    let warehouseName = null;
    let purchaser = null;
    let vendorNum = null;
    let vendorName = null;
    let HandlingCost = null;
    let MiscCost = null;
    let ShippingCost = null;
    let priceAdjustment = null;
    let CRV = 0;
    let TaxRate = 0;
    let TotalCRV = 0;
    let RCVTotal = 0;
    let RCVFinal = 0;
    let InvoiceFinalPrice = 0;
    let TaxableItems = 0;
    let vendorDescription = null, OrderDate = null, ETADate = null, CreateDate = null, totalPrice = this.state.totalPrice, finalPrice = 0;
      PONum = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PONum;
      POTotal = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PO_Total_Price;
      POFinal = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PO_Final_Price;
      vendorNum = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.VendorPicklistNum;
      vendorName = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.VendorName;
      vendorDescription = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.VendorDescription;
      HandlingCost = (this.state.HandlingCost || this.state.HandlingCost == 0) ? this.state.HandlingCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.HandlingCost;
      MiscCost = (this.state.MiscCost || this.state.MiscCost == 0) ? this.state.MiscCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.MiscCost;
      ShippingCost = (this.state.ShippingCost || this.state.ShippingCost == 0) ? this.state.ShippingCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.ShippingCost;
      priceAdjustment = (this.state.priceAdjustment || this.state.priceAdjustment === 0) ? this.state.priceAdjustment : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PriceAdjustment;
      InvoiceFinalPrice = (this.state.InvoiceFinalPrice || this.state.InvoiceFinalPrice == 0) ? this.state.InvoiceFinalPrice : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.InvoiceFinalPrice;
      TaxRate = (this.state.TaxRate || this.state.TaxRate == 0) ? this.state.TaxRate : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.TaxRate;
      //CRV = (this.state.CRV || this.state.CRV == 0) ? this.state.CRV : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.CRV;
      TotalCRV = (this.state.TotalCRV || this.state.TotalCRV == 0) ?  this.state.TotalCRV : 0;
      totalPrice = (parseFloat(totalPrice) || 0) + (parseFloat(this.props.HandlingCost) || 0) + (parseFloat(this.props.MiscCost) || 0) + (parseFloat(this.props.ShippingCost) || 0) + (parseFloat(this.props.priceAdjustment) || 0);
      totalPrice = roundTo(totalPrice, 2).toFixed(2);

      OrderDate = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.OrderDate;
      OrderDate = new Date(OrderDate);

      ETADate = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.ETADate;
      ETADate = new Date(ETADate);

      CreateDate = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PostingDate;
      CreateDate = new Date(CreateDate);

      OrderDate = this.dateStringFormat(OrderDate);
      ETADate = this.dateStringFormat(ETADate);
      CreateDate = this.dateStringFormat(CreateDate);
    if (this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.Warehouse_Receive_Line){
      let details = (this.state.rows.length || this.state.rows.length === 0) ? this.state.rows : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.Warehouse_Receive_Line;
      for (let i = 0; i < details.length; i++){
        let RcvQuantity = details[i].RcvQuantity;
        let RcvUnitPrice = details[i].RcvUnitPrice;
        if (details[i].ProductType === "Fixed" || details[i].ProductType === "Service" || details[i].ProductType === "Non-Product"){
          // RCVTotal += roundTo(RcvQuantity * RcvUnitPrice, 2);
          RCVTotal += roundTo(details[i].RcvTotalPrice, 2);
          if(details[i].IsTaxable)
            TaxableItems += roundTo(RcvQuantity * RcvUnitPrice, 2);
          // RCVFinal += roundTo(RcvQuantity * RcvUnitPrice, 2);
        }else{
          let RcvTotalWeight = details[i].RcvTotalWeight;
          // RCVTotal += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
          RCVTotal += roundTo(details[i].RcvTotalPrice, 2);
          if(details[i].IsTaxable)
            TaxableItems += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
          // RCVFinal += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
        }
        TotalCRV += roundTo(details[i].CRV * RcvQuantity, 2);
      }
    }
    TaxableItems = roundTo((TaxableItems * (TaxRate/100)), 2);
    RCVFinal += RCVTotal + roundTo(parseFloat(ShippingCost), 2) + roundTo(parseFloat(HandlingCost), 2) + roundTo(parseFloat(priceAdjustment), 2) + roundTo(parseFloat(MiscCost), 2) + TotalCRV + TaxableItems;
    RCVTotal = roundTo(RCVTotal, 2).toFixed(2);
    RCVFinal = roundTo(RCVFinal, 2).toFixed(2);
    const { currentReceiveHistoryDetail } = this.props;
    const defaultWarehouseID = { value: currentReceiveHistoryDetail && currentReceiveHistoryDetail.Warehouse_id};
    const showReceivePrice = !checkPermission('no_show_product_cost');
    return (
      <Panel>
        <Col xs={ 2 }>
          <label className="receive-form-label"><Translate value="details" /></label>
          <Row>
            <label className="col-sm-5 marginTopStyle po-information"><Translate value="receipt_no" /></label>
            <Col sm={ 7 }>
              <Field name="WarehouseReceiveNum" component={ DisabledInputField }/>
            </Col>
          </Row>
          <Row>
            <label className="col-sm-5 marginTopStyle po-information" ><Translate value="vendor_inv" /></label>
            <Col sm={ 7 }>
              <Field name="InvoiceNum" component={ InputField }/>
            </Col>
          </Row>
          <Row>
            <label className="col-sm-5 marginTopStyle po-information" ><Translate value="packing_num" /></label>
            <Col sm={ 7 }>
              <Field name="PackingNum" component={ InputField }/>
            </Col>
          </Row>
          <Row>
            <label className="col-sm-5 marginTopStyle po-information" ><Translate value="warehouse" /></label>
            <Col sm={ 7 }>
              <WarehouseDropdown defaultValue={defaultWarehouseID} />
            </Col>
          </Row>
          {isTN &&<Row>
            <label className="col-sm-5 marginTopStyle po-information" ><Translate value="container_no" />.</label>
            <Col sm={7} style={{ marginTop: '5px' }}>
              {currentReceiveHistoryDetail && currentReceiveHistoryDetail.container_num}
            </Col>
          </Row>}
          {isSV && <Row>
            <label className="col-sm-5 marginTopStyle po-information" ><Translate value="container_no" />.</label>
            <Col sm={7} style={{ marginTop: '5px' }}>
            <Field name="container_num" component={ InputField }/>
              {/* {currentReceiveHistoryDetail && currentReceiveHistoryDetail.container_num} */}
            </Col>
          </Row>}
          {isGGI && <Row>
            <label className="col-sm-5 marginTopStyle po-information" ><Translate value="container_no" /></label>
            <Col sm={7} style={{marginTop: '5px'}}>
              <Field name="container_num" component={InputField} />
            </Col>
            <label className="col-sm-5 marginTopStyle po-information" ><Translate value="cso_no" /></label>
            <Col sm={7} style={{marginTop: '5px'}}>
              <Field name="cso_num" component={InputField} />
            </Col>
          </Row>}
        </Col>
          <Col xs={ 2 }>
            <label className="receive-form-label"><Translate value="vendor" /></label>
            <Row>
              <Col sm={ 3 }>
                <label><Translate value="id" /></label>
              </Col>
              <Col sm={ 9 }>
                <Field name="Vendor_id" component={ Selection } withRef={true} ref="vendorOptions" options={this.state.vendorOptions2} onKeyPress={(event) => {
                }}/>
              </Col>
            </Row>
            <Row>
              <Col sm={ 3 }>
                <label><Translate value="name" /></label>
              </Col>
              <Col sm={ 9 }>
                <Field name="Vendor_id" component={ Selection } withRef={true} ref="vendorOptions" options={this.state.vendorOptions1} onKeyPress={(event) => {
                  }}/>
              </Col>
            </Row>
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="description" /></label>
              </Col>
              <Col sm={ 6 }>
                {vendorDescription}
              </Col>
            </Row>
          </Col>
          <Col xs={ 2 }>
            <label className="receive-form-label"><Translate value="dates" /></label>
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="order_date" /></label>
              </Col>
              <Col sm={ 6 }>
                {OrderDate ? convertLocalDate(OrderDate, 'MM-DD-YY') : null}
              </Col>
            </Row>
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="eta_date" /></label>
              </Col>
              <Col sm={ 6 }>
                {ETADate ? convertLocalDate(ETADate, 'MM-DD-YY') : null}
              </Col>
            </Row>
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="receive_date" /></label>
              </Col>
              <Col sm={ 6 }>
                <Field component={DatePicker} name="PostingDate" />
              </Col>
            </Row>
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="vendor_inv_date" /></label>
              </Col>
              <Col sm={ 6 }>
                <Field component={DatePicker} name="InvoiceDate" />
              </Col>
            </Row>
          </Col>
          <Col xs={ 2 }>
            <label className="receive-form-label"><Translate value="po_info" /></label>
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="po_num" /></label>
              </Col>
              <Col sm={ 6 }>
                {PONum}
              </Col>
            </Row>
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="purchaser" /></label>
              </Col>
              <Col sm={ 6 }>
                {purchaser}
              </Col>
            </Row>
            {(!isVAK || isVAK && showReceivePrice) &&
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="po_total" /></label>
              </Col>
              <Col sm={ 6 }>
                {'$'+numberWithCommas(POTotal)}
              </Col>
            </Row>}
            {(!isVAK || isVAK && showReceivePrice) &&
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="po_final" /></label>
              </Col>
              <Col sm={ 6 }>
                {'$'+numberWithCommas(POFinal)}
              </Col>
            </Row>}
            <Row>
              <label className="col-sm-6 marginTopStyle" ><Translate value="note" /></label>
            </Row>
            <Row>
              <Col sm={ 6 }><Field name="Note" component={ InputField } maxLength={150} style={{ minWidth: '205px', maxWidth: '205px' }}/></Col>
            </Row>
          </Col>
          <Col xs={ 2 }>
            <label className="receive-form-label"><Translate value="price_details" /></label>
            {(!isVAK || isVAK && showReceivePrice) && <Row>
              <Col sm={ 6 }>
                <label><Translate value="receive_total" /><span className="dollar-sign">$$</span></label>
              </Col>
              <Col sm={ 6 }>
                <Field name="ReceiveTotal" component={ DisabledInputField } placeholder={RCVTotal}/>
              </Col>
            </Row>}
            {(!isVAK || isVAK && showReceivePrice) &&
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="receive_final" /><span className="dollar-sign">$$</span></label>
              </Col>
              <Col sm={ 6 }>
                <Field name="ReceiveFinal" component={ DisabledInputField } placeholder={RCVFinal}/>
              </Col>
            </Row>}
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="crv" /></label>
              </Col>
              <Col sm={ 6 }>
                <Field name="TotalCRV" component={ DisabledInputField } placeholder={TotalCRV}/>
              </Col>
            </Row>
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="tax" /></label>
              </Col>
              <Col sm={ 6 }>
                <Field name="TaxRate" component={ InputField }/>
              </Col>
            </Row>
          </Col>
          <Col xs={ 2 }>
            <label className="receive-form-label"></label>
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="shipping" /><span className="dollar-sign">$$</span></label>
              </Col>
              <Col sm={ 6 }>
                <Field name="ShippingCost" component={ InputField } />
              </Col>
            </Row>
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="handling" /><span className="dollar-sign">$$</span></label>
              </Col>
              <Col sm={ 6 }>
                <Field name="HandlingCost" component={ InputField } />
              </Col>
            </Row>
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="misc" /><span className="dollar-sign">$$</span></label>
              </Col>
              <Col sm={ 6 }>
                <Field name="MiscCost" component={ InputField } />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <label><Translate value="adjustments" /><span className="dollar-sign">$$</span></label>
              </Col>
              <Col sm={6}>
                <Field name="PriceAdjustment" component={InputField} />
              </Col>
            </Row>
            <Row>
              <Col sm={ 6 }>
                <label><Translate value="invoice_final" /><span className="dollar-sign">$$</span></label>
              </Col>
              <Col sm={ 6 }>
                <Field name="InvoiceFinalPrice" component={ InputField } />
              </Col>
            </Row>
          </Col>
          {isGGI && <Col xs={2}>
            <label className="receive-form-label"><Translate value="surcharge" /></label>
            <Row>
              <Col sm={6}><label><Translate value='local_ship'/><span className="dollar-sign">$$</span></label></Col>
              <Col sm={6}><Field name="LocalShipCost" component={InputField} /></Col>
            </Row>
            <Row>
              <Col sm={6}><label><Translate value={'storage' }/><span className="dollar-sign">{'$$' }</span></label></Col>
              <Col sm={6}><Field name="StorageCost" component={InputField} /></Col>
            </Row>
            <Row>
              <Col sm={6}><label><Translate value={'custom' } /><span className="dollar-sign">{'$$' }</span></label></Col>
              <Col sm={6}><Field name="CustomCost" component={InputField} /></Col>
            </Row>
            <Row>
              <Col sm={6}><label><Translate value="Other" /><span className="dollar-sign">$$</span></label></Col>
              <Col sm={6}><Field name="OtherCost" component={InputField} /></Col>
            </Row>
            <Row>
              <Col sm={6}><label><Translate value="oversea_ship" /><span className="dollar-sign">$$</span></label></Col>
              <Col sm={6}><Field name="OverseaShipCost" component={InputField} /></Col>
            </Row>
          </Col>}
      </Panel>
    )
  }

  handleKeyPress = (value, event) => {
    if(event.charCode == 13){
      event.preventDefault();
      if(value == 'unitPrice' || value == 'notation') {
        if ((!isNumeric(this.props.quantityValue) ||  this.props.quantityValue < 0) && value !== 'quantity') {
          return;
        }
      }
      ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
    }
  }

  handleFocusAutoSuggest() {
    const autoSuggestField = document.getElementById('purchase-auto-suggest');
    autoSuggestField.focus();
    autoSuggestField.select();
  }

  handleFocusQty = () => {
    ReactDOM.findDOMNode(this.refs['allProd_Quantity'].getRenderedComponent().myInput.refs.input).focus();
    ReactDOM.findDOMNode(this.refs['allProd_Quantity'].getRenderedComponent().myInput.refs.input).select();
  }

  handleOnFocus(event) {
    event.target.select();
  }

  selectInventoryInfo(selectedInventoryRow) {
    this.setState({ selectedInventoryRow });
    let index = _.findIndex(this.props.simplifiedProducts, {'Product_id': selectedInventoryRow.Product_id });
    if (index > -1) {
      if(!(isVAK || isAP)) {
        this.props.fetchProductInfo(this.props.simplifiedProducts[index].Product_id);
      }
      this.props.setPriceValues(this.props.simplifiedProducts[index].ProductCost, this.props.simplifiedProducts[index].LowestSalePrice, 'purchaseOrderForm');
      if((this.props.simplifiedProducts[index].ProductType == "Non-Fixed" || this.props.simplifiedProducts[index].ProductType == "Per-Pound") && (!this.props.simplifiedProducts[index].NetWeight) ) {
        alert("Net Weight Cannot Be 0! Change Net Weight in Product Page!");
      }
      this.props.setDefaultOfForm('Weight', this.props.simplifiedProducts[index].NetWeight, 'purchaseOrderForm');
    }
  }

  checkisValid() {
    if (!isNumeric(this.props.quantityValue) || this.props.quantityValue < 0 || !isNumeric(this.props.unitPrice) || this.props.unitPrice < 0){
      return false;
    }
    return true;
  }

  moveToProductsList = () => {
    const { remark } = this.props;
    const quantity = parseFloat(this.props.quantityValue) || 0;
    let newProduct = {};
    let rows = this.state.rows;
    var selectedInventoryRow = this.state.selectedInventoryRow;
    let checkDuplicate = -1;
    if(this.state.isSpare && isVAK) {
      checkDuplicate = _.findIndex(rows, { 'Product_id': selectedInventoryRow.Product_id, 'Is_Spare': true });
    } else {
      checkDuplicate = _.findIndex(rows, { 'Product_id': selectedInventoryRow.Product_id });
    }

    if (!isCCW && checkDuplicate > -1) {
      alert('Product already exists!');
      if(isGGI || isGFD) {
        this.props.setDefaultOfForm('ConvertNum', '', 'receiveHistoryDetail');
      }
      this.props.setDefaultOfForm('Weight', '', 'receiveHistoryDetail');
      this.props.setDefaultOfForm('Quantity', '', 'receiveHistoryDetail');
      this.props.setDefaultOfForm('unitPrice', '', 'receiveHistoryDetail');
      this.props.setDefaultOfForm('itemNotation', '', 'receiveHistoryDetail');
      this.setState({ suggestValue: '' });
      return;
    }
    if (!this.checkisValid()) {
      return;
    }
    // const index = _.findIndex(simplifiedProducts, { 'Product_id': selectedInventoryRow.Product_id });
    // if (index > -1) {
      // INCOMPLETE: change this to refPrice and fix other places where refPrice
    let refPrice = parseFloat(this.props.unitPrice) || 0;
    if(isGGI) {
      newProduct["RcvSmallUnitPrice"] = refPrice;
      newProduct["ConvertNum"] = this.props.convertNum;
    }

    if (isGFD) {
      newProduct["ConvertNum"] = this.props.convertNum;
      newProduct["purchase_convert_unit"] = this.props.convertNum;
      newProduct["RcvUnitQuantity"] = this.props.convertNum * quantity;
    }

    newProduct["Product_id"] = this.state.selectedInventoryRow.Product_id;
    newProduct["IsTaxable"] = this.state.selectedInventoryRow.IsTaxable;
    newProduct["ProductNum"] = this.state.selectedInventoryRow.ProductNum;
    newProduct["ProductGeneralNum"] = this.state.selectedInventoryRow.ProductNum;
    newProduct["ProductName"] = this.state.selectedInventoryRow.Name;
    newProduct["ProductDescription"] = this.state.selectedInventoryRow.Description;
    newProduct["ProductType"] = this.state.selectedInventoryRow.ProductType;
    newProduct["FOBUnitPrice"] = isGGI? refPrice * Number(this.props.convertNum): isVAK && this.state.isSpare ? 0 : refPrice; //products[index].RefPrice;
    newProduct["CIFUnitPrice"] = isGGI? refPrice * Number(this.props.convertNum): refPrice;; //products[index].RefPrice;
    newProduct["RcvUnitPrice"] = isGGI? refPrice * Number(this.props.convertNum): isVAK && this.state.isSpare ? 0 : refPrice;; //products[index].RefPrice;
    newProduct["ProductUnitOfMeasure"]= this.state.selectedInventoryRow.PackageSize;
    newProduct["ProductRefNum"] = this.state.selectedInventoryRow.RefNum;
    newProduct["RcvQuantity"] = quantity;
    newProduct["RcvTotalWeight"] = this.state.selectedInventoryRow.NetWeight*quantity;
    newProduct["CRV"] = this.state.selectedInventoryRow.CRV;
    newProduct["RtnQuantity"] = 0;
    newProduct["StorageRate"] = 0;
    newProduct["UnitPerPallet"] = "";
    newProduct["Pallet"] = 0;
    if(isAP) {
      newProduct['color'] = '';
      newProduct['po_size_ratio'] = '';
      newProduct['size_ratio'] = '';
    }
    let weightList = [];
    let subWeightList = [];
    if (this.state.selectedInventoryRow.ProductType == "Non-Fixed" || this.state.selectedInventoryRow.ProductType == "Per-Pound"){
      for (let i = 0; i < quantity; i++) {
        weightList.push(this.state.selectedInventoryRow.NetWeight);
        subWeightList.push({ Weight: this.state.selectedInventoryRow.NetWeight });
      }
      newProduct["Weights"] = weightList;
      newProduct["subWeights"] = subWeightList;
    }

    const weight = parseFloat(this.state.selectedInventoryRow.NetWeight) || 0;
    if(this.state.selectedInventoryRow.ProductType == "Per-Pound") {
      if(isGGI) {
        newProduct["RcvTotalPrice"] = roundTo((quantity*refPrice*weight), 2);
      } else {
        let weight = parseFloat(this.state.selectedInventoryRow.PackageSize) || 1;
        newProduct["RcvTotalPrice"] = roundTo((quantity*refPrice*weight), 2);
      }
    }
    else if(this.state.selectedInventoryRow.ProductType == "Non-Fixed") {
      newProduct["RcvTotalPrice"] = roundTo((quantity*refPrice*weight), 2);
    }
    else {
      if(isGGI) {
        newProduct["RcvTotalPrice"] = roundTo((quantity * refPrice * newProduct['ConvertNum']), 2);
      } else {
        newProduct["RcvTotalPrice"] = roundTo((quantity*refPrice), 2);
      }
    }

    if(isAP) {
      newProduct['pkgsize1'] = this.state.selectedInventoryRow.PackageSize_1 || 1;
      newProduct['pkgsize2'] = this.state.selectedInventoryRow.PackageSize_2 || 1;
      newProduct['pkgunit1'] = this.state.selectedInventoryRow.PackageType_2 || 'PCS';
      newProduct['pkgunit2'] = this.state.selectedInventoryRow.MeasureUnit_2 || 'BOX';
    }

    newProduct["Remark"] = remark;
    if(isVAK) {
      newProduct["Is_Spare"] = this.state.isSpare;
      if(this.state.isSpare) {
        newProduct["RcvTotalPrice"] = 0;
      }
    }
    let newRows = [...this.state.rows];
    if(isCCW) {
      newProduct["ProductShiftLife"] = this.state.selectedInventoryRow.ShiftLife || 0,
      newRows.unshift(newProduct);
      newRows = newRows.map((row, index) => {
        return {...row, index};
      })
    } else {
      newRows.unshift(newProduct);
      if(isAP) {
        newRows = newRows.map((row, index) => {
          return {...row, index};
        })
      }
    }
    this.setState({
      rows: newRows,
      quantity: 0,
      productType: null,
      suggestValue: '',
      isSpare: false,
    });
    if(isGGI || isGFD) {
      this.props.setDefaultOfForm('ConvertNum', '', 'receiveHistoryDetail');
    }
    this.props.setDefaultOfForm('Weight', '', 'receiveHistoryDetail');
    this.props.setDefaultOfForm('Quantity', '', 'receiveHistoryDetail');
    this.props.setDefaultOfForm('unitPrice', '', 'receiveHistoryDetail');
    this.props.setDefaultOfForm('itemNotation', '', 'receiveHistoryDetail');
  }

  moveOffFromProductsList = (WarehouseReceiveLine_id, index = -1) => {
    let newRows = [...this.state.rows];
    newRows = newRows.filter(obj => {
      if(obj.WarehouseReceiveLine_id) {
        return obj.WarehouseReceiveLine_id !== WarehouseReceiveLine_id
      } else if(isCCW || isAP) {
        return obj.index != index;
      } else {
        return obj.WarehouseReceiveLine_id !== WarehouseReceiveLine_id
      }
    }
    );
    this.setState({ rows: newRows });
  }

  renderSubtotal = () => {
    let subtotal = 0;
    if (this.state.selectedInventoryRow.ProductType == "Fixed") {
      if (this.props.quantityValue) {
        if(isGGI) {
          subtotal = (parseFloat(this.props.quantityValue) * roundTo(this.props.unitPrice, 2) * this.props.convertNum).toFixed(2)
        } else {
          subtotal = (parseFloat(this.props.quantityValue) * roundTo(this.props.unitPrice, 2)).toFixed(2)
        }
      }
    } else {
      if (this.props.weight) {
        if(isGGI) {
          subtotal = (roundTo(this.props.unitPrice, 2) * parseFloat(this.props.quantityValue) * this.props.convertNum).toFixed(2)
        } else {
          subtotal = (roundTo(this.props.unitPrice, 2) * this.props.weight * parseFloat(this.props.quantityValue)).toFixed(2)
        }
      }
    }
    if(isNaN(subtotal)) {
      subtotal = 0;
    }
    return (
      <Field name="Subtotal" component={DisabledInputField} placeholder={subtotal}/>
    )
  }

  setAllProductQuantity = (quantity) => {
    this.props.setValue('receiveHistoryDetail', 'RcvQuantity', quantity);
  }

  onChange = (e) => {
    this.setState({
      isSpare: e.target.checked,
    })
  }

  renderProductSearch = () => {
    let { selectedInventoryRow } = this.state;
    return (
      <Panel>
        <Row>
          <Col xs={6}>
            <Field name="searchType" component={ renderTypeRadios } />
            {this.renderAutoSuggest()}
          </Col>
          <Col xs={ 6 } id="product-search-outputs">
          {isVAK && <Col xs={1}>
            <label><Translate value="is_spare" /></label>
            <input
            checked={this.state.isSpare}
            onChange={e => {this.onChange(e)}}
            type="checkbox"
            />
            </Col>}
            <Col xs={ 2 } className="pr0">
              <label ><Translate value={isGFD ? "case_qty" : "qty"} /></label>
              <Field name="Quantity" withRef={true} ref="allProd_Quantity" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                    this.handleKeyPress('unitPrice', event)
                }} placeholder="must be > 0"/>
            </Col>
            <Col xs={ 2 } className="pr0">
              <label ><Translate value={isGGI ? 'small_pr': (isGFD && selectedInventoryRow && selectedInventoryRow.ProductType ==='Fixed') ? "case" : "unit"} /><span className="dollar-sign">$$</span></label>
              <Field
                name="unitPrice"
                ref="unitPrice"
                withRef={true}
                component={ InputField }
                placeholder={ "must be > 0" }
                onKeyPress={(event) => {
                  if (event.charCode == 13) {
                    if (!isNumeric(this.props.quantityValue) || this.props.quantityValue < 0 || !isNumeric(this.props.unitPrice) || this.props.unitPrice < 0){
                      return;
                    }
                    // this.handleFocusAutoSuggest();
                    this.setAllProductQuantity(0);
                    this.handleKeyPress('notation', event);
                  }
                }}
                onFocus={this.handleOnFocus}
              />
            </Col>
            {(isGFD) &&
              <Col xs={ 2 } className="pr0">
                <label ><Translate value="convert_num" /></label>
                <Field name="ConvertNum" withRef={true} ref="allProd_ConvertNum" component={ InputField } disabled={true} />
              </Col>
            }
            <Col xs={ 2 }>
              <label><Translate value="net_wt" /></label>
              <Field name="Weight" withRef={true} ref="weight" component={ DisabledInputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                if (event.charCode == 13) {
                  this.handleFocusAutoSuggest();
                  this.moveToProductsList();
                }
              }}/>
            </Col>
            <Col xs={2}>
              <Row>
                <Col xs={ 12 }>
                  <label ><Translate value="subtotal" /></label>
                </Col>
                  {this.renderSubtotal()}
              </Row>
            </Col>
            <Col xs={ (isVAK || isGFD) ? 2 : 4}>
              <label><Translate value="notation" /></label>
              <Field name="itemNotation" withRef={true} ref="notation" maxLength={100} component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                if (event.charCode == 13) {
                  this.handleFocusAutoSuggest();
                  this.moveToProductsList();
                }
              }}/>
            </Col>
            {isVAK && <Col>
            <br/>
            <Button
            bsStyle="success"
            disabled={this.state.selectedInventoryRow.Product_id == null}
            onClick={(e) => {
              this.handleFocusAutoSuggest();
              this.moveToProductsList();
            }}
            >
              +
              </Button>
            </Col>}
          </Col>
        </Row>
      </Panel>
    )
  }

  setRows(rowChosen, weights) {
    let rows = [...this.state.rows];
    rows[rowChosen].subWeights = weights;
    let prevTotalPrice = parseFloat(rows[rowChosen].RcvTotalPrice)||0
    let sumWeights = 0;
    weights.map(w => {
      sumWeights = sumWeights + parseFloat(w.Weight);
    })
    rows[rowChosen].RcvTotalWeight = sumWeights;
    if(isGGI) {
      rows[rowChosen].RcvTotalPrice = sumWeights*(rows[rowChosen].RcvSmallUnitPrice)
    } else {
      rows[rowChosen].RcvTotalPrice = sumWeights*(rows[rowChosen].RcvUnitPrice)
    }
    let totalPrice = (parseFloat(this.state.totalPrice)||0)+rows[rowChosen].RcvTotalPrice-prevTotalPrice
    this.setState({rows, totalPrice: totalPrice})
  }

  header() {
    return (
      <h2 className="mt0"><Translate value="receiving_list" /></h2>
    )
  }

  handleFormSubmitAP(formPropsCopy) {
    this.setState({dirty:false});
    const formProps = Object.assign({}, formPropsCopy);
    // formProps.Warehouse_Receive_Line.forEach((line, index) => {
    //   let expire_datetime = '';
    //   if (line.expire_datetime) {
    //     expire_datetime = moment(new Date(line.expire_datetime)).format();
    //   }
    //   formProps.Warehouse_Receive_Line[index].expire_datetime = expire_datetime;
    // });
    const generateDate = (dateString) => {
      if (!dateString) return '';
      return moment(new Date(dateString)).format()
    }
    const rows = [...Data.Selectors.getRows(this.state)].map(row => ({
      ...row,
      expire_datetime: generateDate(row.expire_datetime),
    }));

    var WarehouseReceiveCompleted_id = this.props.currentReceiveHistoryDetail.WarehouseReceiveCompleted_id;
    var WarehouseReceive_id = this.props.currentReceiveHistoryDetail.WarehouseReceive_id;
    let RCVTotal = 0, RCVFinal = 0;
    let HandlingCost = (this.state.HandlingCost || this.state.HandlingCost == 0) ? this.state.HandlingCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.HandlingCost;
    let MiscCost = (this.state.MiscCost || this.state.MiscCost == 0) ? this.state.MiscCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.MiscCost;
    let ShippingCost = (this.state.ShippingCost || this.state.ShippingCost == 0) ? this.state.ShippingCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.ShippingCost;
    let priceAdjustment = (this.state.priceAdjustment || this.state.priceAdjustment === 0) ? this.state.priceAdjustment : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PriceAdjustment;
    let InvoiceFinalPrice = (this.state.InvoiceFinalPrice || this.state.InvoiceFinalPrice == 0) ? this.state.InvoiceFinalPrice : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.InvoiceFinalPrice;
    let TaxRate = (this.state.TaxRate || this.state.TaxRate == 0) ? this.state.TaxRate : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.TaxRate;
    let TotalCRV = (this.state.TotalCRV || this.state.TotalCRV == 0) ? this.state.TotalCRV : 0;
    let details = (this.state.rows.length || this.state.rows.length === 0) ? this.state.rows : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.Warehouse_Receive_Line;
    let TaxableItems = 0;
    for (let i = 0; i < details.length; i++){
      let RcvQuantity = details[i].RcvQuantity;
      let RcvUnitPrice = details[i].RcvUnitPrice;
      if (details[i].ProductType === "Fixed"  || details[i].ProductType === "Service" || details[i].ProductType === "Non-Product"){
        RCVTotal += roundTo(RcvQuantity * RcvUnitPrice, 2);
        if (details[i].IsTaxable)
          TaxableItems += roundTo(RcvQuantity * RcvUnitPrice, 2);
        RCVFinal += roundTo(RcvQuantity * RcvUnitPrice, 2);
      } else {
        let RcvTotalWeight = details[i].RcvTotalWeight;
        RCVTotal += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
        if (details[i].IsTaxable)
          TaxableItems += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
        RCVFinal += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
      }
      TotalCRV += roundTo(details[i].CRV * RcvQuantity, 2);
    }
    TaxableItems = roundTo((TaxableItems * (TaxRate/100)), 2);
    RCVFinal += roundTo(parseFloat(ShippingCost), 2) + roundTo(parseFloat(HandlingCost), 2) + roundTo(parseFloat(priceAdjustment), 2) + roundTo(parseFloat(MiscCost), 2) + TotalCRV + TaxableItems;
    RCVTotal = parseFloat(roundTo(RCVTotal, 2).toFixed(2));
    RCVFinal = parseFloat(roundTo(RCVFinal, 2).toFixed(2));
    let SyncAp = true;
    // this.props.editReceiveHistory(formProps, rows, null, RCVTotal, RCVFinal, SyncAp);
    this.props.editReceiveHistory(formProps, rows, null, RCVTotal, RCVFinal);
  }

  handleFormSubmit(formPropsCopy) {
    if(isGGI && this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.InvoiceStatus == 'FINALIZED') {
      alert('This Po status is finalized!');
      return
    }
    this.setState({dirty:false});
    const formProps = Object.assign({}, formPropsCopy);
    // formProps.Warehouse_Receive_Line.forEach((line, index) => {
    //   let expire_datetime = '';
    //   if (line.expire_datetime) {
    //     expire_datetime = moment(new Date(line.expire_datetime)).format();
    //   }
    //   formProps.Warehouse_Receive_Line[index].expire_datetime = expire_datetime;
    // });
    const generateDate = (dateString) => {
      if (!dateString) return '';
      if(isCCW) {
        return moment(dateString).endOf('day').format();
      }
      return moment(new Date(dateString)).format()
    }
    const rows = [...Data.Selectors.getRows(this.state)].map(row => ({
      ...row,
      expire_datetime: generateDate(row.expire_datetime),
      ...(((isLAP || isUSPrideMulti || isAPD) || isCCW) ? {package_date: generateDate(row.package_date)} : {}),
    }));

    var WarehouseReceiveCompleted_id = this.props.currentReceiveHistoryDetail.WarehouseReceiveCompleted_id;
    var WarehouseReceive_id = this.props.currentReceiveHistoryDetail.WarehouseReceive_id;
    let RCVTotal = 0, RCVFinal = 0;
    let HandlingCost = (this.state.HandlingCost || this.state.HandlingCost == 0) ? this.state.HandlingCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.HandlingCost;
    let MiscCost = (this.state.MiscCost || this.state.MiscCost == 0) ? this.state.MiscCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.MiscCost;
    let ShippingCost = (this.state.ShippingCost || this.state.ShippingCost == 0) ? this.state.ShippingCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.ShippingCost;
    let priceAdjustment = (this.state.priceAdjustment || this.state.priceAdjustment === 0) ? this.state.priceAdjustment : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PriceAdjustment;
    let InvoiceFinalPrice = (this.state.InvoiceFinalPrice || this.state.InvoiceFinalPrice == 0) ? this.state.InvoiceFinalPrice : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.InvoiceFinalPrice;
    let TaxRate = (this.state.TaxRate || this.state.TaxRate == 0) ? this.state.TaxRate : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.TaxRate;
    let TotalCRV = (this.state.TotalCRV || this.state.TotalCRV == 0) ? this.state.TotalCRV : 0;
    let details = (this.state.rows.length || this.state.rows.length === 0) ? this.state.rows : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.Warehouse_Receive_Line;
    let TaxableItems = 0;
    for (let i = 0; i < details.length; i++){
      if(isVAK && details[i].Is_Spare) {
        continue
      }
      let RcvQuantity = details[i].RcvQuantity;
      let RcvUnitPrice = details[i].RcvUnitPrice;
      if (details[i].ProductType === "Fixed"  || details[i].ProductType === "Service" || details[i].ProductType === "Non-Product"){
        RCVTotal += roundTo(RcvQuantity * RcvUnitPrice, 2);
        if (details[i].IsTaxable)
          TaxableItems += roundTo(RcvQuantity * RcvUnitPrice, 2);
        RCVFinal += roundTo(RcvQuantity * RcvUnitPrice, 2);
      } else {
        let RcvTotalWeight = details[i].RcvTotalWeight;
        RCVTotal += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
        if (details[i].IsTaxable)
          TaxableItems += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
        RCVFinal += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
      }
      TotalCRV += roundTo(details[i].CRV * RcvQuantity, 2);
    }
    TaxableItems = roundTo((TaxableItems * (TaxRate/100)), 2);
    RCVFinal += roundTo(parseFloat(ShippingCost), 2) + roundTo(parseFloat(HandlingCost), 2) + roundTo(parseFloat(priceAdjustment), 2) + roundTo(parseFloat(MiscCost), 2) + TotalCRV + TaxableItems;
    RCVTotal = parseFloat(roundTo(RCVTotal, 2).toFixed(2));
    RCVFinal = parseFloat(roundTo(RCVFinal, 2).toFixed(2));
    let SyncAp = false;
    const validateCasePerLayerAndLayerPerPallet = rows.every(line => {
      return line.case_per_layer && line.layer_per_pallet && isInteger(Number(line.case_per_layer)) && isInteger(Number(line.layer_per_pallet));
    });
    if (isGGI && !validateCasePerLayerAndLayerPerPallet) {
      return alert(`Cases per layer and Layers per pallet must be valid integers.`);
    }
    
    if (isAPD) {
      // !!line.lot_num converts it into a boolean (true if value exists, false if empty/undefined/null/"")
      const validateLotNum = rows.every(line => line.lot_num && line.lot_num.trim() !== "");
      if (!validateLotNum) {
        return alert(`Lot No can not be empty!`);
      }
    }
    // this.props.editReceiveHistory(formProps, rows, null, RCVTotal, RCVFinal, SyncAp);
    this.props.editReceiveHistory(formProps, rows, null, RCVTotal, RCVFinal);

  }

  shouldSaveDisable = () => {
    const { currentReceiveHistoryDetail, isEditingReveiveHistory, currentReceiveHistory } = this.props;
    if (!currentReceiveHistoryDetail) {
      return true;
    }
    if (isVAK && currentReceiveHistory.InvoiceStatus === 'FINALIZED') {
      return true;
    }
    if (currentReceiveHistory && currentReceiveHistory.ArrivalStatus === 'Received' && (isAFG || isMMD)) {
      return true;
    }
    const { PaymentStatus } = currentReceiveHistoryDetail;
    if (PaymentStatus !== 'Partially Paid' && PaymentStatus !== 'Paid') {
      return isEditingReveiveHistory;
    }
    if (!this.props.isEditingReveiveHistory)
      return false;
    return true;
  }

  IFrameIsLoaded = () => {
    if (!this.state.PdfFrameLoaded) {
      const pdfFrame = window.frames["Pdf"];
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PdfFrameLoaded: true });
    }
  }

  renderIFrame() {
    if (this.props.warehouseReceivePdf) {
      const file = window.URL.createObjectURL(this.props.warehouseReceivePdf);
      return (
        <iframe style={{ display: 'none'}} onLoad={this.IFrameIsLoaded} id="Pdf" name="Pdf" src={file} />
      );
    }
  }

  renderPrint() {
    const { currentReceiveHistoryDetail, isEditingReveiveHistory, requestingWarehouseReceivePdf } = this.props;
    let url = '';
    if (currentReceiveHistoryDetail && currentReceiveHistoryDetail.WarehouseReceiveNum) {
      url = ROOT_URL + 'v1/warehouse/receive/print/' + currentReceiveHistoryDetail.WarehouseReceiveNum + '?Bearer=' + localStorage.getItem('token');
    }
    return (
      <Button
        bsStyle='primary'
        type='button'
        disabled={url === '' || isEditingReveiveHistory || requestingWarehouseReceivePdf}
        onClick={() => {
          this.props.printWarehouseReceive(currentReceiveHistoryDetail.WarehouseReceiveNum);
        }}
      >
        <em className='fa fa-print' /><Translate value="print" />
      </Button>
    );
  }

  renderPrintBarcode() {
    return (
      <Button
        bsStyle='primary'
        type='button'
        onClick={() => {
          this.setAutoCodesModalVisibility(true)
        }}
      >
        <em className='fa fa-print' /><Translate value="print_barcode" />
      </Button>
    );
  }

  setLocationSelectModalVisibility = (isLocationSelectModalVisible = false) => this.setState({ isLocationSelectModalVisible });
  handleLocationSelect = ({ location }) => {
    let rows = [...this.state.rows];
    rows = rows.map(row => {
      if(row.WarehouseReceiveLine_id) {
        if (row.WarehouseReceiveLine_id === this.state.editingLine.WarehouseReceiveLine_id) {
          return {
            ...row,
            location,
          }
        }
      } else if(isCCW) {
        if (row.index === this.state.editingLine.index) {
          return {
            ...row,
            location,
          }
        }
      } else {
        if (row.Product_id === this.state.editingLine.Product_id) {
          return {
            ...row,
            location,
          }
        }
      }
      return row
    });
    this.setState({
      rows,
    }, () => {
      this.setLocationSelectModalVisibility();
    })
  }
  handleQCClick = () => {
    this.setState({
      qualityControlModalVisibility: true,
    });
  }

  handleQCClose = (reFetch = false) => {
    this.setState({
      qualityControlModalVisibility: false,
    });
    if (reFetch) {
      this.fetchDetail();
    }
  }

  handleInventoryClick = () => {
    this.setState({
      dispatchLocationModalVisibility: true,
    });
  }

  handleInventoryClose = (reFetch = false) => {
    this.setState({
      dispatchLocationModalVisibility: false,
    });
    if (reFetch) {
      this.fetchDetail();
    }
  }
  handleFinalizeClick = () => {
    this.setState({
      case: 'finalizeConfirm'
    }, () => {
      this.setFinalizeConfirmationModalVisibility(true);
    })
  }

  setFinalizeConfirmationModalVisibility = (isFinalizeConfirmationModalVisible = false) => this.setState({ isFinalizeConfirmationModalVisible });

  setAutoCodesModalVisibility = (isAutoCodesModalVisible = false) => this.setState({ isAutoCodesModalVisible });

  render() {
    const { handleSubmit, submitting, pristine } = this.props;
    let createDialogStyle = {
      width: '500px',
      height: '550px',
      marginLeft: '-15%',
    };
    let qcDialogStyle = {
      width: '910px',
      height: '670px',
      marginTop: '-20%',
    };
    let dpDialogStyle = {
      width: '700px',
      height: '700px',
      marginTop: '-20%',
      marginLeft: '-15%',
    }
    const colorsModalStyle = {
      width: '230px',
      height: '316px',
      marginLeft: '-10%'
    }
    const createColorDialogStyle = {
      width: '200px',
      height: '360px',
      marginLeft: '-8%',
    };
    let createStatueStyle = {
      width: '400px',
      marginLeft: '-15%',
    };
    const Warehouse_id = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.Warehouse_id;
    if (this.props.detailIsLoading && !this.props.error) return <Spinner/>
    else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{this.props.error.message}</div></ContentWrapper>
    else {
      const { isEditingReveiveHistory, currentReceiveHistory, currentReceiveHistoryDetail } = this.props;
      let buttonIcon;
      if (isEditingReveiveHistory) {
        buttonIcon = 'fa-spinner fa-spin';
      } else {
        buttonIcon = 'fa-save';
      }
      
      let isAPDTransfer = false;
      if (isAPD && currentReceiveHistoryDetail && currentReceiveHistoryDetail.IsTransfer) {
        isAPDTransfer = true;
      }
      let qcBtnEnable = currentReceiveHistory ? currentReceiveHistory.ArrivalStatus === 'void' : false
      let dispatchBtnEnable = currentReceiveHistory ? currentReceiveHistory.InvoiceStatus !== 'FINALIZED' && currentReceiveHistory.ArrivalStatus !== 'void' : false
      return (
        <ContentWrapper>
          <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
            <Breadcrumb>
              <Breadcrumb.Item>
                <Translate value="warehouse_management" />
              </Breadcrumb.Item>
              <Breadcrumb.Item active="true">
                <Translate value="edit_receiving" />
              </Breadcrumb.Item>
            </Breadcrumb>
            <ButtonToolbar>
              {false &&
                <Button
                  bsStyle="success"
                  disabled={this.shouldSaveDisable()}
                  type="button"
                  onClick={handleSubmit(this.handleFormSubmitAP.bind(this))}
                >
                  <em className={`fa ${buttonIcon}`}/>&nbsp;Save & Sync AP
                </Button>
              }
              {isVAK && <Button bsStyle="primary" type="button" disabled={!checkPermission('view_rcv_qc') || qcBtnEnable} onClick={this.handleQCClick}>
                <Translate value="quality_control"/>
              </Button>}
              {isVAK && <Button bsStyle="primary" disabled={!(dispatchBtnEnable && checkPermission("dispatch_location_rcv"))} type="button" onClick={this.handleInventoryClick}>
                <Translate value="dispatch_location"/>
              </Button>}
              <Button
                bsStyle="success"
                disabled={this.shouldSaveDisable()}
                type="button"
                onClick={handleSubmit(this.handleFormSubmit.bind(this))}
              >
                <em className={`fa ${buttonIcon}`}/>{isSV ? " Save & Sync" : <Translate value="save" />}
              </Button>
              { this.renderPrint() }
              { isCCW && this.renderPrintBarcode() }
              <Button
                onClick={()=>{ this.context.router.push("/inventories/receiveHistory"); }}
                bsStyle="danger"
                type="button"
              >
                <em className="fa fa-close" /><Translate value="cancel" />
              </Button>
            </ButtonToolbar>
            <Grid fluid="true" id="create-inventory-receive">
              <Row> {this.header()} </Row>
              <Row> {this.renderPOInformation()} </Row>
              {!isAPDTransfer && this.renderProductSearch()}
              <Row style={{ marginTop: "8px" }}>
                <Panel className={isCCW ? "table-collapse-fix-xl" : "table-collapse-fix"}>
                  <h4><Translate value="receive_history_detail" /></h4>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                    {this.renderTotalWeight()}
                  </div>
                  <hr/>
                  {this.renderTable() }
                  <hr/>
                </Panel>
              </Row>
            </Grid>
          </form>
          <LocationSelectModal
            setModalVisibility={this.setLocationSelectModalVisibility}
            isVisible={this.state.isLocationSelectModalVisible}
            onConfirm={this.handleLocationSelect}
            selectedWarehouse={this.props.warehouse || Warehouse_id }
            editingLine={this.state.editingLine}
          />
          <AutoCodesModal
          setModalVisibility={this.setAutoCodesModalVisibility}
          isVisible={this.state.isAutoCodesModalVisible}
          print={this.props.printCode}
          data={this.state.originRows}
          />
          {this.renderIFrame()}
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.setWeightOpen} onCloseClicked={() => {
              this.closeSetWeight()
          } } title="Set Product Weights">
              {/* <SetReceiveWeightModal closeC={this.closeSetWeight} totalLoaded={ this.state.totalLoaded } rowChosen={ this.state.rowChosen } rows={(this.state.rowChosen > -1) && (this.state.rows[this.state.rowChosen]) && (this.state.rows[this.state.rowChosen].subWeights) && [...this.state.rows[this.state.rowChosen].subWeights] } setRows={this.setRows}/> */}
              <SetWeightModal invoice oldLoaded={this.state.oldQty} setWeights={this.setWeights} keepLoaded={this.keepLoaded} currentWeights={this.state.currentWeights} closeC={this.closeSetWeight} totalLoaded={this.state.totalLoaded} rowChosen={this.state.rowChosen} returnTotalWeight={this.returnTotalWeight.bind(this)} editedRow={this.state.editedRow} />
          </SkyLightStateless>
          {/* PO Create Open */}
          <div className="remove-close-skylight">
            <SkyLightStateless
              dialogStyles={createDialogStyle}
              isVisible={this.state.confirmOpen}
              onCloseClicked={this.closeConfirm}
              title={<Translate value="your_receiving_has_been_saved" />}
            >
              <br/><br/>
              <Row className="centerStyle">
                { this.props.editedReceiveHistory && this.props.editedReceiveHistory && <h4><Translate value="receive_num" />: {this.props.editedReceiveHistory.WarehouseReceiveNum}</h4>}
              </Row>
              <Row className="centerStyle">
                { this.props.editedReceiveHistory && this.props.editedReceiveHistory && <h4><Translate value="invoice_no" />: {this.props.editedReceiveHistory.InvoiceNum}</h4>}
              </Row>
              <br/>
              <Row className="centerStyle"><h4><Translate value="msg_ask_if_stay_on_current_page" /></h4></Row>
              <br/><br/>
              <ButtonToolbar className="button-toolbar-center">
                <Button bsStyle="success" onClick={this.closeConfirm} type="button" ><Translate value="yes" /></Button>
                <Button bsStyle="danger" onClick={() => { this.context.router.push('/inventories/receiveHistory'); }} type="button" ><Translate value="no" /></Button>
                { this.renderPrint() }
              </ButtonToolbar>
            </SkyLightStateless>
          </div>
          <SkyLightStateless dialogStyles={qcDialogStyle} isVisible={this.state.qualityControlModalVisibility} onCloseClicked={this.handleQCClose} title={<Translate value="quality_control" />}>
            <SetQualityControlModal receiveDetails={this.props.currentReceiveHistoryDetail} rows={this.state.rows} onClose={this.handleQCClose} />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={dpDialogStyle} isVisible={this.state.dispatchLocationModalVisibility} onCloseClicked={this.handleInventoryClose} title={<Translate value="dispatch_location" />}>
            <SetDispatchLocationModal
              receiveDetails={this.props.currentReceiveHistoryDetail}
              rows={this.state.rows}
              onClose={this.handleInventoryClose}
              qualifiedLocationOptions={this.state.qualifiedLocationOptions}
              unqualifiedLocationOptions={this.state.unqualifiedLocationOptions}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createStatueStyle} isVisible={this.state.isFinalizeConfirmationModalVisible} onCloseClicked={() => { this.setFinalizeConfirmationModalVisibility(); }} title={<Translate value="finalize" />}>
            <ConfirmActionModal
              case={this.state.case}
              onConfirm={this.handleFinalizeConfirm}
              onCancel={this.setFinalizeConfirmationModalVisibility}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={colorsModalStyle} 
          isVisible={this.state.productColorsVisible} 
          title={<Translate value="colors" />} 
          onCloseClicked={this.handleCloseColorsVisible}>
            <ProductColorsModal
            addColor={() => {
              this.setState({
                productColorsVisible: false,
                productEditColorsVisible: true,
              });
            }}
            update={this.handleUpdateColorByProductId}
            clear={this.handleClearColorByProductId}
            Product_id={this.state.currentProductId}/>
          </SkyLightStateless>
         
          <SkyLightStateless
            dialogStyles={createColorDialogStyle}
            isVisible={this.state.productEditColorsVisible}
            onCloseClicked={this.handleCloseEditColorsVisible}
            title={<Translate value="colors" />}
          >
            <ProductEditColorsModal
              Product_id={this.state.currentProductId}
            />
          </SkyLightStateless>
        </ContentWrapper>
      );
    }
  }
}

export default withRouter(ReceiveHistoryDetail);

function roundTo(n, digits) {
 if (digits === undefined) {
   digits = 0;
 }

 var multiplicator = Math.pow(10, digits);
 n = parseFloat((n * multiplicator).toFixed(11));
 var test =(Math.round(n) / multiplicator);
 return +(test.toFixed(2));
}

let renderTypeRadios = props => {
  return (
    <div className="form-group" id="search-product-by" style={{ paddingBottom: '10px' }}>
      <label className="col-xs-4 search-by-max-width">
        <Translate value="search_by" />
      </label>
      <label className="col-xs-2" >
        <input {...props.input} type="radio" value="ProductNum"
          checked={props.input.value === "ProductNum"}/>
        <Translate value="prod_num" />
      </label>
      <label className="col-xs-2">
        <input {...props.input} type="radio" value="RefNum"
          checked={props.input.value === "RefNum"}/>
        <Translate value={isOLG ? "item_no" : "ref_num"} />
      </label>
      <label className="col-xs-2" >
        <input {...props.input} type="radio" value="Name"
          checked={props.input.value === "Name"}/>
        <Translate value="name" />
      </label>
      <label className="col-xs-2" >
        <input {...props.input} type="radio" value="Description"
          checked={props.input.value === "Description"}/>
        <Translate value="description" />
      </label>
    </div>
  )
}



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/receiveHistoryDetail.jsx